
<template>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet">
  
  <div class="dashboard">
    <!-- Loading Spinner -->
    <div v-if="loading.profile && !profile" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ t('dashboard.loading') }}</span>
      </div>
    </div>

    <!-- Main Dashboard Content -->
    <div class="container-fluid" v-else>
      <div class="row">
        <!-- Sidebar -->
        <nav class="col-12 col-lg-3 col-xl-2 sidebar bg-light border-end vh-100" :class="{ 'show': sidebarVisible }">
          <div class="position-sticky pt-3">
            <button class="btn-close d-lg-none position-absolute end-0 top-0 mt-3 me-3" @click="toggleSidebar"></button>
            
            <!-- Logo/Brand -->
            <div class="d-flex align-items-center mb-3 px-3">
              <i class="fas fa-qrcode fs-4 me-2"></i>
              <span class="fs-5 fw-semibold">neolinks</span>
            </div>
            
            <!-- Navigation Menu -->
            <ul class="nav flex-column ps-0" id="v-pills-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0 active" @click="handleMenuClick"
                   id="v-pills-dashboard-tab" data-bs-toggle="pill" href="#v-pills-dashboard" role="tab">
                  <i class="fas fa-home me-3"></i>
                  <span>{{ t('dashboard.sidebar.dashboard') }}</span>
                </a>
              </li>

              <!-- QR Code tab - visible si abonnement actif -->
              <li class="nav-item" v-if="hasActiveSubscription">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-qrcode-tab" data-bs-toggle="pill" href="#v-pills-qrcode" role="tab">
                  <i class="fas fa-qrcode me-3"></i>
                  <span>{{ t('dashboard.sidebar.qrcode') }}</span>
                </a>
              </li>
              
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-upgrade-plan-tab" data-bs-toggle="pill" href="#v-pills-upgrade-plan" role="tab">
                  <i class="fas fa-star me-3"></i>
                  <span>{{ t('dashboard.sidebar.upgrade') }}</span>
                </a>
              </li>
              
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-edit-card-tab" data-bs-toggle="pill" href="#v-pills-edit-card" role="tab">
                  <i class="fas fa-cog me-3"></i>
                  <span>{{ t('dashboard.sidebar.editProfile') }}</span>
                </a>
              </li>
              
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-social-links-tab" data-bs-toggle="pill" href="#v-pills-social-links" role="tab">
                  <i class="fas fa-globe me-3"></i>
                  <span>{{ t('dashboard.sidebar.socialLinks') }}</span>
                </a>
              </li>


              <li class="nav-item">
  <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
     id="v-pills-services-tab" data-bs-toggle="pill" href="#v-pills-services" role="tab">
    <i class="fas fa-th-large me-3"></i>
    <span>{{ t('dashboard.sidebar.services') }}</span>
  </a>
</li>
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-profile-photos-tab" data-bs-toggle="pill" href="#v-pills-profile-photos" role="tab">
                  <i class="fas fa-image me-3"></i>
                  <span>{{ t('dashboard.sidebar.profilePhotos') }}</span>
                </a>
              </li>

              <li class="nav-item" v-if="hasActiveSubscription">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-appearance-tab" data-bs-toggle="pill" href="#v-pills-appearance" role="tab">
                  <i class="fas fa-palette me-3"></i>
                  <span>{{ t('dashboard.sidebar.appearance') }}</span>
                </a>
              </li>
              
              <li class="nav-item d-none" v-if="canAccessPhotos">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-photos-tab" data-bs-toggle="pill" href="#v-pills-photos" role="tab">
                  <i class="fas fa-images me-3"></i>
                  <span>{{ t('dashboard.sidebar.photos') }}</span>
                </a>
              </li>
              
              <li class="nav-item">
                <a class="nav-link d-flex align-items-center ps-0" @click="handleMenuClick"
                   id="v-pills-logout-tab" data-bs-toggle="pill" href="#v-pills-logout" role="tab">
                  <i class="fas fa-sign-out-alt me-3"></i>
                  <span>{{ t('dashboard.sidebar.logout') }}</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        
        <!-- Main Content Area -->
        <main class="col-lg-9 col-xl-10 ms-sm-auto px-md-4">
          <!-- Header -->
          <header class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div>
              <h1 class="h2">{{ profile ? `${t('dashboard.header.welcome')}, ${profile.name}` : t('dashboard.header.welcomeDefault') }}</h1>
            </div>
            
            <div class="btn-toolbar mb-2 mb-md-0 d-flex gap-2">
              <!-- Menu toggle -->
              <button class="btn p-0 d-lg-none" @click="toggleSidebar">
                <i class="fas fa-bars fs-5"></i>
              </button>
              
              <!-- Profile dropdown -->
          
              <!-- Business Mode Toggle -->
<div class="d-flex align-items-center gap-3">
  <div class="business-mode-header">
    <span class="text-muted small me-2">{{ t('dashboard.profile.businessMode') }}</span>
    <div class="form-check form-switch mb-0">
      <input 
        class="form-check-input" 
        type="checkbox" 
        role="switch" 
        id="headerBusinessModeSwitch"
        :checked="profile.show_contact_button == 1"
        @change="toggleBusinessMode"
        style="width: 2.5rem; height: 1.25rem;">
      <label class="form-check-label" for="headerBusinessModeSwitch"></label>
    </div>
  </div>
  
  <!-- Menu dropdown -->
  <div class="dropdown">
  
    
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
      <li><a class="dropdown-item" href="#v-pills-edit-card" data-bs-toggle="pill">
        <i class="fas fa-user me-2"></i>{{ t('dashboard.dropdown.editProfile') }}
      </a></li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <router-link to="/connexion" class="dropdown-item" @click="handleLogout">
          <i class="fas fa-sign-out-alt me-2"></i>{{ t('dashboard.dropdown.logout') }}
        </router-link>
      </li>
    </ul>
  </div>
</div>


            </div>
          </header>
          
          <!-- Notifications -->
          <div v-if="notification" :class="`alert alert-${notification.type} alert-dismissible fade show`" role="alert">
            {{ notification.message }}
            <button type="button" class="btn-close" @click="notification = null"></button>
          </div>
          
          <!-- Subscription Warning -->
          <div v-if="!hasActiveSubscription" class="alert alert-warning mb-4">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ t('dashboard.notification.activateSubscription') }} 
            <a href="javascript:void(0)" @click="activateUpgradePlan" class="alert-link">{{ t('dashboard.notification.activateLink') }}</a> 
            {{ t('dashboard.notification.activateText') }}
          </div>

          <!-- Tab Content -->
          <div class="tab-content" id="v-pills-tabContent">
            <!-- Dashboard Tab -->
            <div class="tab-pane fade show active" id="v-pills-dashboard" role="tabpanel" aria-labelledby="v-pills-dashboard-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.analytics.title') }}</h5>
                </div>

                <div class="card-body">
                  <!-- Loading Spinner -->
                  <div v-if="loading.stats" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">{{ t('dashboard.loading') }}</span>
                    </div>
                    <p class="mt-2">{{ t('dashboard.analytics.loading') }}</p>
                  </div>
                  
                  <div v-else>
                    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4">
                      <!-- Total des scans -->
                      <div class="col">
                        <div class="card text-bg-primary">
                          <div class="card-body">
                            <h6 class="card-subtitle mb-2 text-white">{{ t('dashboard.analytics.totalScans') }}</h6>
                            <h2 class="card-title">{{ dashboardStats.totalScans.toLocaleString('fr-FR') }}</h2>
                            <p class="card-text">
                              <small :class="dashboardStats.scanGrowth >= 0 ? 'text-success text-white' : 'text-danger text-white'">
                                {{ dashboardStats.scanGrowth >= 0 ? '+' : '' }}{{ dashboardStats.scanGrowth.toLocaleString('fr-FR') }}% {{ t('dashboard.analytics.lastMonth') }}
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Visiteurs uniques -->
                      <div class="col">
                        <div class="card text-bg-warning">
                          <div class="card-body">
                            <h6 class="card-subtitle mb-2 text-muted">{{ t('dashboard.analytics.uniqueVisitors') }}</h6>
                            <h2 class="card-title">{{ dashboardStats.uniqueVisitors.toLocaleString('fr-FR') }}</h2>
                            <p class="card-text">
                              <small :class="dashboardStats.uniqueGrowth >= 0 ? 'text-success' : 'text-danger'">
                                {{ dashboardStats.uniqueGrowth >= 0 ? '+' : '' }}{{ dashboardStats.uniqueGrowth.toLocaleString('fr-FR') }}% {{ t('dashboard.analytics.lastMonth') }}
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Taux de conversion -->
                      <div class="col">
                        <div class="card text-bg-info">
                          <div class="card-body">
                            <h6 class="card-subtitle mb-2 text-muted">{{ t('dashboard.analytics.conversionRate') }}</h6>
                            <h2 class="card-title">{{ dashboardStats.conversionRate.toLocaleString('fr-FR') }}%</h2>
                            <p class="card-text">
                              <small :class="dashboardStats.conversionGrowth >= 0 ? 'text-success' : 'text-danger'">
                                {{ dashboardStats.conversionGrowth >= 0 ? '+' : '' }}{{ dashboardStats.conversionGrowth.toLocaleString('fr-FR') }}% {{ t('dashboard.analytics.lastMonth') }}
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Lien le plus cliqué -->
                      <div class="col">
                        <div class="card text-bg-success">
                          <div class="card-body">
                            <h6 class="card-subtitle mb-2">{{ t('dashboard.analytics.topLink') }}</h6>
                            <h2 class="card-title">{{ dashboardStats.topLink.platform }}</h2>
                            <p class="card-text">
                              <small class="text-white">{{ dashboardStats.topLink.percentage }}% {{ t('dashboard.analytics.totalClicks') }}</small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Recent Scans Table -->
                    <div class="card">
                      <div class="card-header">
                        <h5 class="card-title">{{ t('dashboard.analytics.recentScans') }}</h5>
                      </div>
                      <div class="card-body">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>{{ t('dashboard.analytics.date') }}</th>
                              <th>{{ t('dashboard.analytics.location') }}</th>
                              <th>{{ t('dashboard.analytics.device') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="dashboardStats.recentScans.length === 0">
                              <td colspan="3" class="text-center">{{ t('dashboard.analytics.noRecentScans') }}</td>
                            </tr>
                            <tr v-for="(scan, index) in dashboardStats.recentScans" :key="index">
                              <td>{{ scan.date }}</td>
                              <td>{{ scan.location }}</td>
                              <td>{{ scan.device }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
         <!-- Edit Profile Tab -->


         <!-- Edit Profile Tab -->

         
         <!-- Edit Profile Tab -->
<div class="tab-pane fade" id="v-pills-edit-card" role="tabpanel" aria-labelledby="v-pills-edit-card-tab">
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">{{ t('dashboard.profile.title') }}</h5>
    </div>
    <div class="card-body">
      
      <form @submit.prevent="updateProfile" class="needs-validation">
        <div class="mb-3">
          <label for="name" class="form-label text-start">{{ t('dashboard.profile.fullName') }}</label>
          <input type="text" class="form-control" id="name" v-model="profile.name" required>
        </div>
        
        <div class="mb-3">
          <label for="bio" class="form-label text-start">{{ t('dashboard.profile.bio') }}</label>
          <textarea class="form-control" id="bio" v-model="profile.bio" rows="3"></textarea>
        </div>
        
        <div class="mb-3">
          <label for="company" class="form-label text-start">{{ t('dashboard.profile.company') }}</label>
          <input type="text" class="form-control" id="company" v-model="profile.company">
        </div>
        
        <div class="mb-3">
          <label for="mobile" class="form-label text-start">{{ t('dashboard.profile.mobile') }}</label>
          <input type="tel" class="form-control" id="mobile" v-model="profile.mobile">
        </div>
        
        <!-- Business Mode Toggle -->
   

        
        <!-- Bouton responsive amélioré -->
      
        <!-- Bouton responsive amélioré -->



        <!-- Bouton responsive amélioré -->
        <div class="mt-4 text-md-center">
            <button type="submit" class="btn btn-dark btn-responsive">
    {{ t('dashboard.profile.saveChanges') }}
  </button>
</div>
      </form>
    </div>
  </div>
</div>
            
            <!-- Social Links Tab -->
            <div class="tab-pane fade" id="v-pills-social-links" role="tabpanel" aria-labelledby="v-pills-social-links-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.social.title') }}</h5>
                </div>
                <div class="card-body">
                  <!-- Current Social Links -->
                  <div v-if="socialLinks && socialLinks.length > 0" class="d-flex align-items-center flex-wrap gap-2 mb-3">
                    <span v-for="link in socialLinks" :key="link.id" class="badge bg-secondary p-2 d-flex align-items-center">
                      <i :class="link.icon" class="me-1"></i>
                      {{ link.title || link.platform }}
                      <button @click="deleteSocialLink(link.id)" class="btn btn-sm ms-2 p-0 text-white">
                        <i class="fas fa-times"></i>
                      </button>
                    </span>
                  </div>
                  
                  <!-- Message if no social links -->
                  <div v-else class="alert alert-info mb-3">
                    {{ t('dashboard.social.noLinks') }}
                  </div>
                  
                  <!-- Add Social Link Form -->
                  <form @submit.prevent="addSocialLink" class="mt-3">
                    <div class="row g-3">
                      <div class="col-md-4">
                  

                        <select v-model="newSocialLink.platform" class="form-select" id="socialPlatform" required @change="updateSocialIcon">
  <option value="">{{ t('dashboard.social.selectType') }}</option>
  <option value="custom" data-icon="fas fa-link">🔗 {{ t('dashboard.social.customLink') }}</option>

  <option value="LinkedIn" data-icon="fab fa-linkedin">💼 LinkedIn</option>
  <option value="Instagram" data-icon="fab fa-instagram">📷 Instagram</option>
  <option value="Facebook" data-icon="fab fa-facebook">📘 Facebook</option>
  <option value="X" data-icon="fab fa-x-twitter">🐦 X (Twitter)</option>
  <option value="TikTok" data-icon="fab fa-tiktok">🎵 TikTok</option>
  <option value="YouTube" data-icon="fab fa-youtube">🎥 YouTube</option>
  <option value="Telegram" data-icon="fab fa-telegram">💬 Telegram</option>
  <option value="Snapchat" data-icon="fab fa-snapchat">👻 Snapchat</option>
  <option value="Website" data-icon="fas fa-globe">🌐 Site Web</option>
</select>
                      </div>
                      
                      <!-- Champ nom pour les liens personnalisés -->
                      <div v-if="newSocialLink.platform === 'custom'" class="col-md-3">
                        <input 
                          type="text" 
                          v-model="newSocialLink.customTitle" 
                          class="form-control" 
                          :placeholder="t('dashboard.social.customNamePlaceholder')" 
                          required
                          maxlength="50">
                        <small class="text-muted">{{ t('dashboard.social.customName') }}</small>
                      </div>
                      
                      <div :class="newSocialLink.platform === 'custom' ? 'col-md-3' : 'col-md-6'">
                        <input type="url" v-model="newSocialLink.url" class="form-control" :placeholder="t('dashboard.social.urlPlaceholder')" required>
                      </div>
                      
                      <div class="col-md-2">
                        <button type="submit" class="btn btn-success w-100">
                          <i class="fas fa-plus"></i> {{ t('dashboard.social.add') }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>



            <!-- Services Tab -->
<div class="tab-pane fade" id="v-pills-services" role="tabpanel" aria-labelledby="v-pills-services-tab">
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">{{ t('dashboard.services.title') }}</h5>
      <p class="text-muted small mb-0">{{ t('dashboard.services.description') }}</p>
    </div>
    <div class="card-body">
      
      <!-- Services existants -->
      <div v-if="services && services.length > 0" class="mb-4">
        <h6 class="mb-3">{{ t('dashboard.services.current') }}</h6>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
          <div v-for="service in services" :key="service.id" class="col">
            <div class="card service-card h-100">
              <div class="card-body text-center p-3">
                <!-- Icône du service -->
                <div class="service-icon-container mb-2">
                  <img v-if="service.icon_path" 
                    :src="`${BASE_URL}${service.icon_path}`" 
                    :alt="service.name"
                    class="service-icon">
                  <div v-else class="service-icon-placeholder">
                    <i class="fas fa-cog"></i>
                  </div>
                </div>
                
                <!-- Nom du service -->
                <h6 class="service-name">{{ service.name }}</h6>
                <small class="text-muted">{{ service.type === 'button' ? t('dashboard.services.typeButton') : t('dashboard.services.typeLink') }}</small>
                
                <!-- Actions -->
                <div class="service-actions mt-3">
                  <input type="file" 
                    :ref="`serviceIcon${service.id}`" 
                    @change="uploadServiceIcon($event, service.id)" 
                    accept="image/*" 
                    style="display: none">
                  
                  <button @click="$refs[`serviceIcon${service.id}`][0].click()" 
                    class="btn btn-sm btn-outline-primary me-2">
                    <i class="fas fa-image"></i>
                  </button>
                  
                  <button @click="deleteService(service.id)" 
                    class="btn btn-sm btn-outline-danger">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Message si aucun service -->
      <div v-else-if="!loading.services" class="alert alert-info text-center">
        <i class="fas fa-info-circle me-2"></i>
        {{ t('dashboard.services.noServices') }}
      </div>
      
      <!-- Loading -->
      <div v-if="loading.services" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ t('dashboard.loading') }}</span>
        </div>
      </div>
      
      <!-- Formulaire d'ajout -->
      <div class="border-top pt-4 mt-4">
        <h6 class="mb-3">{{ t('dashboard.services.addNew') }}</h6>
        
        <form @submit.prevent="addService">
          <div class="row g-3">
            <!-- Type de service -->
            <div class="col-md-4">
              <label class="form-label">{{ t('dashboard.services.type') }}</label>
              <select v-model="newService.type" class="form-select">
                <option value="link">{{ t('dashboard.services.typeLink') }}</option>
                <option value="button">{{ t('dashboard.services.typeButton') }}</option>
              </select>
            </div>
            
            <!-- Nom du service -->
            <div class="col-md-4">
              <label class="form-label">{{ t('dashboard.services.name') }}</label>
              <input type="text" 
                v-model="newService.name" 
                class="form-control" 
                :placeholder="t('dashboard.services.namePlaceholder')" 
                required>
            </div>
            
            <!-- URL -->
            <div class="col-md-4">
              <label class="form-label">{{ t('dashboard.services.url') }}</label>
              <input type="url" 
                v-model="newService.url" 
                class="form-control" 
                :placeholder="t('dashboard.services.urlPlaceholder')" 
                required>
            </div>
            
            <!-- Icône (optionnelle) -->
            <div class="col-12">
              <label class="form-label">{{ t('dashboard.services.icon') }} ({{ t('dashboard.services.optional') }})</label>
              <div class="d-flex align-items-center gap-3">
                <input type="file" 
                  ref="newServiceIcon" 
                  @change="uploadServiceIcon($event)" 
                  accept="image/*" 
                  class="form-control" 
                  style="max-width: 300px;">
                
                <!-- Aperçu de l'icône -->
                <div v-if="newService.icon_path" class="icon-preview">
                  <img :src="newService.icon_path" alt="Preview" class="preview-icon">
                </div>
              </div>
            </div>
            
            <!-- Bouton d'ajout -->
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-primary">
                <i class="fas fa-plus me-2"></i>
                {{ t('dashboard.services.add') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
            
            <!-- Photos Tab -->
            <div class="tab-pane fade" id="v-pills-photos" role="tabpanel" aria-labelledby="v-pills-photos-tab">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="card-title">{{ t('dashboard.photos.title') }}</h5>
                  <div>
                    <input type="file" ref="photoInput" @change="addPhoto" accept="image/*" style="display: none">
                    <button @click="$refs.photoInput.click()" class="btn btn-success">
                      <i class="fas fa-plus me-1"></i> {{ t('dashboard.photos.addPhoto') }}
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div v-if="photos && photos.length > 0" class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
                    <div v-for="photo in photos" :key="photo.id" class="col">
                      <div class="card h-100">
                        <img :src="`/api${photo.photo_path}`" 
                          class="card-img-top" 
                          alt="Photo" 
                          style="height: 200px; object-fit: cover;">
                        <div class="card-body">
                          <div class="d-flex justify-content-between align-items-center">
                            <small class="text-muted">{{ t('dashboard.photos.photo') }} {{photo.id}}</small>
                            <button 
                              @click="deletePhoto(photo.id)"
                              class="btn btn-danger btn-sm"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Message if no photos -->
                  <div v-else class="alert alert-info">
                    {{ t('dashboard.photos.noPhotos') }}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Upgrade Plan Tab -->
            <div class="tab-pane fade" id="v-pills-upgrade-plan" role="tabpanel" aria-labelledby="v-pills-upgrade-plan-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.subscription.title') }}</h5>
                </div>
                <div class="card-body">
                  <!-- Current Active Subscription -->
                  <div v-if="hasActiveSubscription" class="mb-4 p-3 border border-success rounded d-flex align-items-center w-100">
                    <div class="me-auto">
                      <h5 class="mb-1">{{ currentSubscription?.package_name || t('dashboard.subscription.currentPlan') }}</h5>
                      <p class="mb-0 text-muted">{{ t('dashboard.subscription.validUntil') }} {{ formatDate(subscriptionEndDate) }}</p>
                    </div>
                    <span class="badge bg-success">
                      <i class="fas fa-check-circle me-1"></i>{{ t('dashboard.subscription.active') }}
                    </span>
                  </div>
                  
                  <!-- No Subscription Message -->
                  <div v-else class="mb-4 p-3 border rounded">
                    <h5 class="mb-1">{{ t('dashboard.subscription.choosePlan') }}</h5>
                  </div>
                  
                  <!-- Basic Plan -->
                  <div class="mb-4 p-3 border rounded d-flex align-items-center w-100"
                    :class="{'border-success': currentSubscription?.package_id === 1}">
                    <div class="me-auto">
                      <h5 class="mb-1">{{ t('dashboard.subscription.classic') }}</h5>
                      <p class="mb-0 text-muted">{{ t('dashboard.subscription.classicDescription') }}</p>
                      <p class="mb-0">15$ / an</p>
                    </div>
                    <button v-if="currentSubscription?.package_id === 1" 
                      class="btn btn-success" disabled>
                      <i class="fas fa-check-circle me-1"></i>{{ t('dashboard.subscription.currentPlanButton') }}
                    </button>
                    <button v-else @click="handleSubscription(1)" 
                      class="btn btn-primary">
                      {{ hasActiveSubscription ? t('dashboard.subscription.changePlan') : t('dashboard.subscription.choosePlanButton') }}
                    </button>
                  </div>
                  
                  <!-- Pro Plan -->
                  <div class="mb-4 p-3 border rounded d-flex align-items-center w-100"
                    :class="{'border-success': currentSubscription?.package_id === 2}">
                    <div class="me-auto">
                      <h5 class="mb-1">{{ t('dashboard.subscription.professional') }}</h5>
                      <p class="mb-0 text-muted">{{ t('dashboard.subscription.professionalDescription') }}</p>
                      <p class="mb-0">25$ / an</p>
                    </div>
                    <button v-if="currentSubscription?.package_id === 2" 
                      class="btn btn-success" disabled>
                      <i class="fas fa-check-circle me-1"></i>{{ t('dashboard.subscription.currentPlanButton') }}
                    </button>
                    <button v-else @click="handleSubscription(2)" 
                      class="btn btn-primary">
                      {{ hasActiveSubscription ? t('dashboard.subscription.upgrade') : t('dashboard.subscription.choosePlanButton') }}
                    </button>
                  </div>
                  
                  <!-- Enterprise Plan -->
                  <div class="p-3 border rounded d-flex align-items-center w-100">
                    <div class="me-auto">
                      <h5 class="mb-1">{{ t('dashboard.subscription.enterprise') }}</h5>
                      <p class="mb-0 text-muted">{{ t('dashboard.subscription.enterpriseDescription') }}</p>
                    </div>
                    <button @click="contactSales" class="btn btn-outline-primary">
                      {{ t('dashboard.subscription.contactSales') }}
                    </button>
                  </div>
                </div>
              </div>
              
              <!-- Contact Sales Modal -->
              <div class="modal" id="contactModal" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{{ t('dashboard.contact.title') }}</h5>
                      <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body text-center">
                      <div class="mb-4">
                        <i class="fab fa-whatsapp text-success" style="font-size: 3rem;"></i>
                        <h6 class="mt-2">{{ t('dashboard.contact.whatsapp') }}</h6>
                        <a href="https://wa.me/+25377604069" target="_blank" class="btn btn-success">
                          <i class="fab fa-whatsapp me-2"></i>+253 77 60 40 69
                        </a>
                      </div>
                      <div>
                        <i class="fas fa-envelope text-primary" style="font-size: 3rem;"></i>
                        <h6 class="mt-2">{{ t('dashboard.contact.email') }}</h6>
                        <a href="mailto:support@neo-link.me" class="btn btn-primary">
                          <i class="fas fa-envelope me-2"></i>support@neo-link.me
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Profile Photos Tab -->
            <div class="tab-pane fade" id="v-pills-profile-photos" role="tabpanel" aria-labelledby="v-pills-profile-photos-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.profilePhotos.title') }}</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- Photo de profil -->
                    <div class="col-md-6 mb-4">
                      <div class="card h-100">
                        <div class="card-header text-center">
                          <h6 class="card-title mb-0">{{ t('dashboard.profilePhotos.profilePicture') }}</h6>
                        </div>
                        <div class="card-body text-center">
                          <!-- Image avec chemin corrigé -->
                          <div v-if="profile?.avatar_path" class="mb-3">
                            <img :src="`${BASE_URL}${profile.avatar_path}`" :alt="t('dashboard.profilePhotos.profilePicture')" 
                                 class="img-thumbnail rounded-circle" style="width: 150px; height: 150px; object-fit: cover;">
                          </div>
                          <!-- Image par défaut -->
                          <div v-else class="mb-3 d-flex justify-content-center">
                            <div class="bg-secondary rounded-circle d-flex align-items-center justify-content-center" 
                                 style="width: 150px; height: 150px;">
                              <i class="fas fa-user text-white" style="font-size: 4rem;"></i>
                            </div>
                          </div>
                          
                          <input type="file" ref="avatarInput" @change="uploadAvatar" accept="image/*" style="display: none">
                          <button @click="$refs.avatarInput.click()" class="btn btn-primary w-100">
                            <i class="fas fa-camera me-2"></i>
                            {{ profile?.avatar_path ? t('dashboard.profilePhotos.editProfile') : t('dashboard.profilePhotos.addProfile') }}
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Image de couverture -->
                    <div class="col-md-6 mb-4">
                      <div class="card h-100">
                        <div class="card-header text-center">
                          <h6 class="card-title mb-0">{{ t('dashboard.profilePhotos.coverImage') }}</h6>
                        </div>
                        <div class="card-body text-center">
                          <!-- Image avec chemin corrigé -->
                          <div v-if="profile?.banner_path" class="mb-3">
                            <img :src="`${BASE_URL}${profile.banner_path}`" :alt="t('dashboard.profilePhotos.coverImage')" 
                                 class="img-thumbnail" style="width: 100%; height: 150px; object-fit: cover;">
                          </div>
                          <!-- Image par défaut -->
                          <div v-else class="mb-3">
                            <div class="bg-light border d-flex align-items-center justify-content-center" 
                                 style="width: 100%; height: 150px;">
                              <i class="fas fa-image text-muted" style="font-size: 4rem;"></i>
                            </div>
                          </div>
                          
                          <input type="file" ref="bannerInput" @change="uploadBanner" accept="image/*" style="display: none">
                          <button @click="$refs.bannerInput.click()" class="btn btn-primary w-100">
                            <i class="fas fa-image me-2"></i>
                            {{ profile?.banner_path ? t('dashboard.profilePhotos.editCover') : t('dashboard.profilePhotos.addCover') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="alert alert-info mt-3">
                    <i class="fas fa-info-circle me-2"></i>
                    {{ t('dashboard.profilePhotos.info') }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Appearance Tab -->
            <div class="tab-pane fade" id="v-pills-appearance" role="tabpanel" aria-labelledby="v-pills-appearance-tab">
              <div class="card">
                <div class="card-header d-flex justify-content-between">
                  <h5 class="card-title">{{ t('dashboard.appearance.title') }}</h5>
                </div>
                <div class="card-body">
                  <p class="mb-4">{{ t('dashboard.appearance.description') }}</p>
                  
                  <!-- Filtres de catégories -->
                  <div class="theme-categories mb-4">
                    <button 
                      v-for="category in themeCategories" 
                      :key="category"
                      @click="filterThemesByCategory(category)"
                      :class="['btn', currentCategory === category ? 'btn-dark' : 'btn-outline-dark', 'me-2', 'mb-2']">
                      {{ category }}
                    </button>
                    <button 
                      @click="filterThemesByCategory('Tous')"
                      :class="['btn', currentCategory === 'Tous' ? 'btn-dark' : 'btn-outline-dark', 'me-2', 'mb-2']">
                      {{ t('dashboard.appearance.all') }}
                    </button>
                  </div>
                  
                  <!-- Grille de thèmes -->
                  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    <div 
                      v-for="theme in filteredThemes" 
                      :key="theme.id"
                      class="col">
                      <div 
                        :class="['card h-100 theme-card', currentThemeId === theme.id ? 'selected' : '']"
                        @click="selectTheme(theme.id)">
                        <div class="theme-preview" :style="getThemeColor(theme)">
                          <div class="theme-name">{{ theme.name }}</div>
                        </div>
                        <div class="card-body">
                          <h6 class="card-title">{{ theme.name }}</h6>
                          <p class="card-text small text-muted">{{ theme.description }}</p>
                          <span v-if="currentThemeId === theme.id" class="badge bg-dark position-absolute top-0 end-0 m-2">
                            <i class="fas fa-check me-1"></i>{{ t('dashboard.appearance.active') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Aperçu -->
                  <div v-if="selectedThemeId && selectedThemeId !== currentThemeId" class="text-center mt-4">
                    <button @click="saveTheme" class="btn btn-dark px-4">
                      <i class="fas fa-save me-2"></i>{{ t('dashboard.appearance.apply') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Logout Tab -->
            <div class="tab-pane fade" id="v-pills-logout" role="tabpanel" aria-labelledby="v-pills-logout-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.logout.title') }}</h5>
                </div>
                <div class="card-body text-center">
                  <p>{{ t('dashboard.logout.confirm') }}</p>
                  <button @click="handleLogout" class="btn btn-danger">
                    <i class="fas fa-sign-out-alt me-2"></i>{{ t('dashboard.logout.button') }}
                  </button>
                </div>
              </div>
            </div>

            <!-- QR Code Tab -->
            <div class="tab-pane fade" id="v-pills-qrcode" role="tabpanel" aria-labelledby="v-pills-qrcode-tab">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">{{ t('dashboard.qrcode.title') }}</h5>
                </div>
                <div class="card-body">
                  <!-- QR Code existant -->
                  <div v-if="hasActiveSubscription && profile?.qr_code_path" class="text-center">
                    <div class="qr-code-container mb-4">
                      <img :src="`${BASE_URL}${profile.qr_code_path}`" alt="QR Code" class="img-fluid" style="max-width: 250px;" />
                    </div>
                    
                    <div class="input-group mb-4">
                      <input type="text" class="form-control" readonly :value="profile.profile_url" ref="profileUrlInput">
                      <button class="btn btn-outline-dark" type="button" @click="copyProfileUrl">
                        <i class="fas fa-copy"></i> {{ t('dashboard.qrcode.copy') }}
                      </button>
                    </div>
                    
                    <a :href="profile.profile_url" target="_blank" class="btn btn-primary">
                      <i class="fas fa-external-link-alt me-2"></i> {{ t('dashboard.qrcode.openProfile') }}
                    </a>
                  </div>
                  
                  <!-- Générer QR Code -->
                  <div v-else-if="hasActiveSubscription && !profile?.qr_code_path" class="text-center py-4">
                    <div class="mb-4">
                      <i class="fas fa-qrcode fs-1 text-muted mb-3"></i>
                      <h5>{{ t('dashboard.qrcode.noQRCode') }}</h5>
                      <p class="text-muted">{{ t('dashboard.qrcode.generateDescription') }}</p>
                    </div>
                    
                    <button @click="generateQRCode" class="btn btn-primary btn-lg" :disabled="loading.qrcode">
                      <i class="fas fa-qrcode me-2"></i>
                      <span v-if="loading.qrcode">{{ t('dashboard.qrcode.generating') }}</span>
                      <span v-else>{{ t('dashboard.qrcode.generate') }}</span>
                    </button>
                  </div>
                  
                  <!-- Abonnement requis -->
                  <div v-else class="text-center py-4">
                    <div class="mb-4">
                      <i class="fas fa-lock fs-1 text-muted mb-3"></i>
                      <h5>{{ t('dashboard.qrcode.premiumFeature') }}</h5>
                      <p class="text-muted">{{ t('dashboard.qrcode.subscriptionRequired') }}</p>
                    </div>
                    
                    <button @click="activateUpgradePlan" class="btn btn-primary">
                      <i class="fas fa-crown me-2"></i> {{ t('dashboard.qrcode.activateSubscription') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    
    <!-- Payment Modal -->
<div v-if="showPaymentModal" class="payment-modal">
  <div class="payment-content">
    <button class="close-button" @click="closePaymentModal">×</button>
    <h5 class="text-center mb-4">{{ t('dashboard.payment.title') }}</h5>
    
    <div class="payment-options">
      <!-- Option Wafi -->
      <div class="payment-card"
           :class="{ selected: selectedPaymentMethod === 'wafi' }"
           @click="selectPaymentMethod('wafi')">
        <div class="payment-icon bg-info">
          <i class="fas fa-credit-card"></i>
        </div>
    <div class="payment-details">
  <h6 class="mb-1">
    <i class="fas fa-shield-alt text-success me-2"></i>
    Wafi - Digital Payment
  </h6>
  
  <!-- Cartes centrées -->
  <div class="card-logos">
    <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" alt="Visa" class="card-logo">
    <img src="https://upload.wikimedia.org/wikipedia/commons/b/b7/MasterCard_Logo.svg" alt="Mastercard" class="card-logo">
    <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="American Express" class="card-logo">
  </div>
          
          <!-- Icône seulement -->
       
        </div>
        <div class="check-icon" v-if="selectedPaymentMethod === 'wafi'">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>
    </div>
        
      
      <!-- Dans Dashboard.vue - Payment summary avec prix USD -->


<div class="payment-summary mt-4">
  <h6 class="mb-3">{{ t('dashboard.payment.orderSummary') }}</h6>
  <div class="d-flex justify-content-between mb-2">
    <span>{{ t('dashboard.payment.subscription') }}</span>
    <span class="fw-bold">{{ selectedPackage?.name || 'N/A' }}</span>
  </div>
  <div class="d-flex justify-content-between mb-2">
    <span>{{ t('dashboard.payment.duration') }}</span>
    <span class="fw-bold">{{ t('dashboard.payment.oneYear') }}</span>
  </div>
  <div class="d-flex justify-content-between">
    <span>{{ t('dashboard.payment.price') }}</span>
    <span class="fw-bold">${{ selectedPackage?.price || '0' }} USD</span>
  </div>
  <hr class="my-3">
  <div class="d-flex justify-content-between">
    <span class="fw-bold fs-5">{{ t('dashboard.payment.total') }}</span>
    <span class="fw-bold fs-5">${{ selectedPackage?.price || '0' }} USD</span>
  </div>
  <p class="small text-muted mt-2 mb-0">
    {{ t('dashboard.payment.paymentNote') }}
  </p>
</div>
        
        <button class="btn btn-primary w-100 mt-4 py-3" 
          :disabled="!selectedPaymentMethod"
          @click="processPayment">
          <i class="fas fa-lock me-2"></i> {{ t('dashboard.payment.validate') }}
        </button>
      </div>
    </div>
 
  </div>
</template>

<script>


import { useTranslation } from '@/composables/useTranslation'

import { dashboardService } from '../services/api';
import * as bootstrap from 'bootstrap';

export default {
  name: "DashboardView",

 setup() {
    const { t } = useTranslation()
    return { t }
  },
  
  
  data() {
    return {
      // UI state
      notification: null,
      sidebarVisible: false,
      BASE_URL: '',
      dashboardStats: {
      totalScans: 0,
      scanGrowth: 0,
      uniqueVisitors: 0,
      uniqueGrowth: 0,
      conversionRate: 0,
      conversionGrowth: 0,
      topLink: { platform: 'Aucun', percentage: 0 },
      recentScans: [],
        newSocialLink: {
      platform: '',
      url: '',
      icon: '',
      customTitle: '' // NOUVEAU: pour les liens personnalisés
    },
    },

//themes 
themes: [],
    currentThemeId: null,
    selectedThemeId: null,
    currentCategory: 'Tous',
      // User data
      user: null,
      profile: {
        name: '',
        bio: '',
        company: '',
        mobile: '',
        email: '',
        avatar_path: null,
        packageId: null,
        package_name: null,
        show_contact_button: "1" // Initialisé comme chaîne pour v-model avec input radio

      },
      socialLinks: [],
      photos: [],
      
      // Subscription data
      packages: [],
      currentSubscription: null,
      hasActiveSubscription: false,
      subscriptionEndDate: null,
      
      // Payment modal
      selectedPackage: null,
      selectedPaymentMethod: null,
      showPaymentModal: false,
      
      // Form data
      newSocialLink: {
        platform: '',
        url: '',
        icon: ''
      },
      

      services: [], // NOUVEAU: liste des services
    newService: {  // NOUVEAU: formulaire service
      name: '',
      url: '',
      type: 'link',
      icon_path: null
    },
      // Loading states
      loading: {
        profile: true,
        avatar: false,
        photos: false,
        socialLinks: false,
        qrcode: false,
        banner: false, // Ajoutez cette ligne
        stats: false,

        themes: false,
          payment: false  ,// IMPORTANT: cette ligne doit être présente
          services: false // NOUVEAU



      }
    }
  },
  
  created() {

    this.initializeUser();
    this.loadDashboardStats();
    this.loadThemes();

  },
  
  methods: {

    async loadDashboardStats() {
    try {
      if (!this.user || !this.user.id) return;
      
      this.loading.stats = true;
      const response = await dashboardService.getDashboardStats(this.user.id);
      
      if (response.data && response.data.success) {
        this.dashboardStats = response.data.data;
      }
    } catch (error) {
      console.error('Erreur de chargement des statistiques:', error);
      // En cas d'erreur, garder les valeurs par défaut
    } finally {
      this.loading.stats = false;
    }
  },
  
  // Formatage des dates pour le tableau

    // Utility methods
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    
    handleMenuClick() {
      if (window.innerWidth <= 991) {
        this.sidebarVisible = false;
      }
    },
    
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    
    // User initialization
    initializeUser() {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          this.user = JSON.parse(userStr);
          this.loadAllData();
          this.loadSubscriptionData();
        } catch(e) {
          console.error('Erreur lors de l\'analyse des données utilisateur', e);
          this.$router.push('/connexion');
        }
      } else {
        this.$router.push('/connexion');
      }
    },
    

    async generateQRCode() {
    try {
      this.loading.qrcode = true;
      const response = await dashboardService.generateQRCode(this.user.id);
      
      if (response.data && response.data.success) {
        // Mettre à jour les données du profil avec le nouveau QR code
        this.profile.qr_code_path = response.data.data.qr_code_path;
        this.profile.profile_url = response.data.data.profile_url;
        
        this.notification = {
          type: 'success',
          message: 'QR code généré avec succès'
        };
      } else {
        throw new Error(response.data?.message || 'Erreur lors de la génération du QR code');
      }
    } catch (error) {
      console.error('Erreur de génération de QR code:', error);
      this.notification = {
        type: 'danger',
        message: error.response?.data?.message || 'Erreur lors de la génération du QR code'
      };
    } finally {
      this.loading.qrcode = false;
    }
  },
  
  copyProfileUrl() {
    const urlInput = this.$refs.profileUrlInput;
    urlInput.select();
    document.execCommand('copy');
    
    this.notification = {
      type: 'info',
      message: 'Lien copié dans le presse-papier'
    };
  
},
    // Data loading
    async loadAllData() {
      try {
        this.loading.profile = true;
        
        // Utiliser dashboardService au lieu d'axios directement
        const [profileRes, socialRes, packagesRes] = await Promise.all([
          dashboardService.getProfile(this.user.id),
          dashboardService.getSocialLinks(this.user.id),
          dashboardService.getPackages()
        ]);
        

        await this.loadServices();

        // Traitement des données du profil
        if (profileRes.data && profileRes.data.data) {
          this.profile = {
            ...this.profile,
            ...profileRes.data.data
          };
          
          // Vérifier les fonctionnalités disponibles selon le package
          this.checkPackageFeatures();
        }
        
        // Traitement des liens sociaux
        if (socialRes.data && socialRes.data.data) {
          this.socialLinks = socialRes.data.data || [];
        }
        
        // Traitement des packages
        if (packagesRes.data && packagesRes.data.data) {
          this.packages = packagesRes.data.data || [];
        }
        
        // Charger les photos uniquement si l'utilisateur a accès à cette fonctionnalité
        if (this.canAccessPhotos) {
          try {
            const photosRes = await dashboardService.getPhotos(this.user.id);
            if (photosRes.data && photosRes.data.data) {
              this.photos = photosRes.data.data || [];
            }
          } catch (error) {
            console.error('Erreur lors du chargement des photos:', error);
          }
        }
      } // Dans la méthode loadAllData(), dans le bloc catch:
catch (error) {
  console.error('Erreur lors du chargement des données:', error);
  
  // Changer le message selon l'état de l'abonnement
  this.notification = {
    type: 'danger', // Changé de danger à warning pour un style différent
message: this.t('dashboard.error.subscriptionRequired')
  };
  
  // En cas d'erreur, initialiser un profil vide par défaut
  this.profile = {
    name: '',
    bio: '',
    company: '',
    mobile: '',
    email: '',
    packageId: 1,
    package_name: 'Basic'
  };
} finally {
        this.loading.profile = false;
      }
    },
    
    async loadSubscriptionData() {
      try {
        const response = await dashboardService.getSubscription(this.user.id);
        
        if (response.data && response.data.success && response.data.data) {
          this.currentSubscription = response.data.data;
          this.hasActiveSubscription = this.currentSubscription.statut === 1;
          
          // Calculer la date de fin (1 an après la création)
          const startDate = new Date(this.currentSubscription.created_at);
          this.subscriptionEndDate = new Date(startDate.setFullYear(startDate.getFullYear() + 1));
          
          // S'assurer que les fonctionnalités sont correctement activées
          this.checkPackageFeatures();
        } else {
          this.resetSubscriptionData();
        }
      } catch (error) {
        console.error('Erreur lors du chargement de l\'abonnement:', error);
        this.resetSubscriptionData();
      }
    },
    
    // Vérifier les fonctionnalités accessibles selon le package
    checkPackageFeatures() {
      // Vérifier l'ID du package à partir des différentes sources possibles
      const packageId = 
        this.profile?.packageId || 
        this.profile?.package_id || 
        (this.currentSubscription ? this.currentSubscription.package_id : null);
      
      // Définir les drapeaux de fonctionnalités
      // Les photos sont accessibles uniquement avec les forfaits Pro (id=2) ou Entreprise (id=3)
      this.canAccessPhotos = packageId === 2 || packageId === 3;
    },
    
    // Gestion du profil
    async updateProfile() {
      try {
        this.loading.profile = true;
        
        const updatedData = {
          name: this.profile.name || '',
          bio: this.profile.bio || '',
          company: this.profile.company || '',
          mobile: this.profile.mobile || '',
          show_contact_button: parseInt(this.profile.show_contact_button) // Convertir en nombre

        };
        
        const response = await dashboardService.updateProfile(this.user.id, updatedData);
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Profil mis à jour avec succès'
          };
          
          // Recharger les données pour avoir les valeurs les plus récentes
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de la mise à jour');
        }
      } catch (error) {
        console.error('Erreur de mise à jour du profil:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de la mise à jour du profil'
        };
      } finally {
        this.loading.profile = false;
      }
    },
    
    async uploadAvatar(event) {
      try {
        const file = event.target.files[0];
        if (!file) return;
        
        this.loading.avatar = true;
        
        const formData = new FormData();
        formData.append('avatar', file);
        
        const response = await dashboardService.uploadAvatar(this.user.id, formData);
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Photo de profil mise à jour'
          };
          
          // Recharger les données pour obtenir le nouveau chemin de l'avatar
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de l\'upload');
        }
      } catch (error) {
        console.error('Erreur d\'upload d\'avatar:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de l\'upload de l\'avatar'
        };
      } finally {
        this.loading.avatar = false;
      }
    },
    

    activateUpgradePlan() {
  // Utiliser l'API Bootstrap pour montrer l'onglet
  const tabEl = document.getElementById('v-pills-upgrade-plan-tab');
  const tab = new bootstrap.Tab(tabEl);
  tab.show();
  
  // Fermer le menu latéral sur mobile
  if (window.innerWidth <= 991) {
    this.sidebarVisible = false;
  }
},
    // Gestion des liens sociaux
    updateSocialIcon() {
      const selectElement = document.getElementById('socialPlatform');
      const selectedOption = selectElement ? selectElement.options[selectElement.selectedIndex] : null;
      
      if (selectedOption && selectedOption.dataset.icon) {
        this.newSocialLink.icon = selectedOption.dataset.icon;
      } else {
        this.newSocialLink.icon = 'fas fa-link'; // Icône par défaut
      }
    },
    
async addSocialLink() {
  try {
    if (!this.newSocialLink.platform || !this.newSocialLink.url) {
      this.notification = {
        type: 'warning',
        message: 'Veuillez sélectionner un type et saisir une URL'
      };
      return;
    }

    // NOUVEAU: Validation pour les liens personnalisés
    if (this.newSocialLink.platform === 'custom' && !this.newSocialLink.customTitle) {
      this.notification = {
        type: 'warning',
        message: 'Veuillez saisir un nom pour votre lien personnalisé'
      };
      return;
    }
    
    // S'assurer que l'icône est définie
    if (!this.newSocialLink.icon) {
      this.updateSocialIcon();
    }
    
   const linkData = {
  platform: this.newSocialLink.platform === 'custom' ? 'custom' : this.newSocialLink.platform, // MODIFIÉ
  title: this.newSocialLink.platform === 'custom' ? this.newSocialLink.customTitle : null,
  url: this.newSocialLink.url,
  icon: this.newSocialLink.icon,
  type: this.newSocialLink.platform === 'custom' ? 'custom' : 'social',
  user_id: this.user.id
};
    
    const response = await dashboardService.addSocialLink(this.user.id, linkData);
    
    if (response.data && response.data.success) {
      this.notification = {
        type: 'success',
        message: this.newSocialLink.platform === 'custom' ? 'Lien personnalisé ajouté avec succès' : 'Réseau social ajouté avec succès'
      };
      
      // Réinitialiser le formulaire
      this.newSocialLink = {
        platform: '',
        url: '',
        icon: '',
        customTitle: '' // NOUVEAU
      };
      
      // Recharger les liens
      await this.loadAllData();
    } else {
      throw new Error(response.data?.message || 'Erreur lors de l\'ajout');
    }
  } catch (error) {
    console.error('Erreur d\'ajout de lien:', error);
    this.notification = {
      type: 'danger',
      message: error.response?.data?.message || 'Erreur lors de l\'ajout'
    };
  }
},  
    
    async deleteSocialLink(linkId) {
      try {
        const response = await dashboardService.deleteSocialLink(this.user.id, linkId);
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Réseau social supprimé avec succès'
          };
          
          // Recharger les liens sociaux
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de la suppression');
        }
      } catch (error) {
        console.error('Erreur de suppression de lien social:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de la suppression du réseau social'
        };
      }
    },
    
    // Gestion des photos
    async addPhoto(event) {
      try {
        const file = event.target.files[0];
        if (!file) return;
        
        this.loading.photos = true;
        
        const formData = new FormData();
        formData.append('photo', file);
        
        const response = await dashboardService.addPhoto(this.user.id, formData);
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Photo ajoutée avec succès'
          };
          
          // Recharger les photos
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de l\'ajout de la photo');
        }
      } catch (error) {
        console.error('Erreur d\'ajout de photo:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de l\'ajout de la photo'
        };
      } finally {
        this.loading.photos = false;
      }
    },
    
    async deletePhoto(photoId) {
      try {
        const response = await dashboardService.deletePhoto(this.user.id, photoId);
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Photo supprimée avec succès'
          };
          
          // Recharger les photos
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de la suppression');
        }
      } catch (error) {
        console.error('Erreur de suppression de photo:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de la suppression de la photo'
        };
      }
    },
    
    // Gestion des abonnements
    async subscribe(packageId) {
      try {
        const response = await dashboardService.subscribe({
          userId: this.user.id,
          packageId: packageId
        });
        
        if (response.data && response.data.success) {
          this.notification = {
            type: 'success',
            message: 'Abonnement activé avec succès'
          };
          
          // Recharger les données d'abonnement
          await this.loadSubscriptionData();
          // Recharger le profil pour mettre à jour les fonctionnalités
          await this.loadAllData();
        } else {
          throw new Error(response.data?.message || 'Erreur lors de l\'activation');
        }
      } catch (error) {
        console.error('Erreur d\'abonnement:', error);
        this.notification = {
          type: 'danger',
          message: error.response?.data?.message || 'Erreur lors de l\'activation de l\'abonnement'
        };
      }
    },
    
   
   handleSubscription(packageId) {
  if (this.hasActiveSubscription) {
    this.contactSales();
  } else {
    // Trouver le package avec prix USD
    const foundPackage = this.packages.find(p => p.id === packageId);
    this.selectedPackage = foundPackage || {
      id: packageId,
      name: packageId === 1 ? 'Essentiel' : 'Professionnel',
      price: packageId === 1 ? 15 : 25 // Prix en USD
    };
    
    console.log('📦 Package sélectionné:', this.selectedPackage);

        this.selectedPaymentMethod = 'wafi';

    this.showPaymentModal = true;
  }
},

 


 async processPayment() {
  try {
    if (!this.selectedPaymentMethod || !this.selectedPackage) {
      this.notification = {
        type: 'warning',
        message: 'Veuillez sélectionner un mode de paiement'
      };
      return;
    }
    
    console.log('💳 === TRAITEMENT PAIEMENT ===');
    console.log('💳 Méthode:', this.selectedPaymentMethod);
    console.log('📦 Package:', this.selectedPackage);
    
    this.loading.payment = true;
    
    if (this.selectedPaymentMethod === 'wafi') {
      console.log('🚀 Initiation paiement WaafiPay');
      
      // Données pour WaafiPay (montant en USD)
      const paymentData = {
        userId: this.user.id,
        packageId: this.selectedPackage.id,
        amountUSD: this.selectedPackage.price // Prix en USD depuis la base
      };
      
      console.log('📤 Données envoyées:', paymentData);
      
      // Afficher notification de traitement
      this.notification = {
        type: 'info',
        message: 'Initialisation du paiement WaafiPay...'
      };
      
      const response = await dashboardService.initiateWafiPayment(paymentData);
      
      console.log('📥 Réponse reçue:', response.data);
      
      if (response.data && response.data.success && response.data.data.hppUrl) {
        console.log('✅ HPP URL reçue:', response.data.data.hppUrl);
        
        // Fermer modal avant redirection
        this.showPaymentModal = false;
        this.selectedPaymentMethod = null;
        
        // Notification de redirection
        this.notification = {
          type: 'success',
          message: `Redirection vers WaafiPay pour le paiement de $${paymentData.amountUSD} USD...`
        };
        
        // Redirection vers WaafiPay après délai
        setTimeout(() => {
          console.log('🔄 Redirection vers WaafiPay...');
          window.location.href = response.data.data.hppUrl;
        }, 2000);
        
      } else {
        throw new Error('Erreur lors de l\'initialisation du paiement WaafiPay');
      }
    } 
    else if (this.selectedPaymentMethod === 'cash') {
      // Logique cash avec prix USD
      const message = encodeURIComponent(`Bonjour, je souhaite activer mon abonnement neolink (Plan: ${this.selectedPackage.name}, Prix: $${this.selectedPackage.price} USD). Mon identifiant est: ${this.user.id}.`);
      window.open(`https://wa.me/25377120079?text=${message}`, '_blank');
      
      const paymentData = {
        userId: this.user.id,
        packageId: this.selectedPackage.id,
        paymentMethod: 'cash',
        statut_paiement: 'en_attente'
      };
      
      await dashboardService.processSubscriptionCash(paymentData);
      this.notification = {
        type: 'info',
        message: 'Votre demande de paiement en espèces a été envoyée.'
      };
      
      this.showPaymentModal = false;
      this.selectedPaymentMethod = null;
    }
    else {
      this.notification = {
        type: 'info',
        message: 'Cette méthode de paiement sera bientôt disponible.'
      };
      
      this.showPaymentModal = false;
      this.selectedPaymentMethod = null;
    }
    
  } catch (error) {
    console.error('❌ === ERREUR PAIEMENT ===');
    console.error(error);
    
    this.notification = {
      type: 'danger',
      message: error.response?.data?.message || error.message || 'Erreur lors du paiement'
    };
  } finally {
    this.loading.payment = false;
  }
},
    resetSubscriptionData() {
      this.hasActiveSubscription = false;
      this.currentSubscription = null;
      this.subscriptionEndDate = null;
    },
    
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
    },
    
    closePaymentModal() {
      this.showPaymentModal = false;
      this.selectedPaymentMethod = null;
    },
    
    contactSales() {
      document.getElementById('contactModal').style.display = 'block';
      document.body.classList.add('modal-open');
    },

    // Dans la partie methods du composant
async uploadBanner(event) {
  try {
    const file = event.target.files[0];
    if (!file) return;
    
    this.loading.banner = true;
    
    const formData = new FormData();
    formData.append('banner', file);
    
    const response = await dashboardService.uploadBanner(this.user.id, formData);
    
    if (response.data && response.data.success) {
      this.notification = {
        type: 'success',
        message: 'Image de couverture mise à jour'
      };
      
      // Mettre à jour le profil avec le type de bannière personnalisée
      this.profile.banner_path = response.data.data.banner_path;
      this.profile.banner_type = 'custom';
    } else {
      throw new Error(response.data?.message || 'Erreur lors de l\'upload');
    }
  } catch (error) {
    console.error('Erreur d\'upload de bannière:', error);
    this.notification = {
      type: 'danger',
      message: error.response?.data?.message || 'Erreur lors de l\'upload de l\'image de couverture'
    };
  } finally {
    this.loading.banner = false;
  }
},
    
    closeModal() {
      document.getElementById('contactModal').style.display = 'none';
      document.body.classList.remove('modal-open');
    },
    
    // Déconnexion
    async handleLogout() {
      try {
        await dashboardService.logout();
        
        // Effacer le stockage local
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        
        // Rediriger vers la connexion
        this.$router.push('/connexion');
      } catch (error) {
        console.error('Erreur de déconnexion:', error);
        
        // Même en cas d'erreur, effacer le stockage et rediriger
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        this.$router.push('/connexion');
      }
    },
    async loadThemes() {
    try {
      this.loading.themes = true;
      const response = await dashboardService.getAllThemes();
      
      if (response.data && response.data.success) {
        this.themes = response.data.data;
      }
      
      // Charger le thème actuel de l'utilisateur
      const currentTheme = await dashboardService.getUserTheme(this.user.id);
      if (currentTheme.data && currentTheme.data.success && currentTheme.data.data) {
        this.currentThemeId = currentTheme.data.data.id;
        this.selectedThemeId = this.currentThemeId;
      }
    } catch (error) {
      console.error('Erreur de chargement des thèmes:', error);
    } finally {
      this.loading.themes = false;
    }
  },
  
  selectTheme(themeId) {
    this.selectedThemeId = themeId;
  },
  
async saveTheme() {
  try {
    if (!this.selectedThemeId) return;
    
    this.loading.themes = true;
    const response = await dashboardService.updateUserTheme(this.user.id, this.selectedThemeId);
    
    if (response.data && response.data.success) {
      // Mettre à jour l'interface avec la nouvelle bannière
      if (response.data.data && response.data.data.bannerPath) {
        this.profile.banner_path = response.data.data.bannerPath;
        this.profile.banner_type = 'theme';
      }
      
      this.notification = {
        type: 'success',
        message: 'Thème et image de couverture mis à jour avec succès'
      };
      
      // Mettre à jour le thème actuel
      this.currentThemeId = this.selectedThemeId;
    } else {
      throw new Error(response.data?.message || 'Erreur lors de la mise à jour du thème');
    }
  } catch (error) {
    console.error('Erreur lors de la mise à jour du thème:', error);
    this.notification = {
      type: 'danger',
      message: 'Erreur lors de la mise à jour du thème'
    };
  } finally {
    this.loading.themes = false;
  }
},
  
  filterThemesByCategory(category) {
    this.currentCategory = category;
  }, 

  // Ajoutez cette méthode simplifiée à votre section methods

getThemeColor(theme) {
  // Couleurs fixes pour chaque thème
  let color = '#333333'; // Par défaut
  
  if (theme.name === 'Minimaliste') color = '#000000';
if (theme.name === 'Zanzibar') color = '#D97742';
  if (theme.name === 'Savane') color = '#E09D2F';
  if (theme.name === 'Nuit Étoilée') color = '#1F4075';
  if (theme.name === 'Oasis') color = '#16877B';
  
  // Générer un dégradé simple
  return {
    background: `linear-gradient(135deg, ${color} 0%, ${this.lightenDarkenColor(color, -30)} 100%)`
  };
},

// Fonction simplifiée pour ajuster une couleur (éclaircir/assombrir)
lightenDarkenColor(hex, amount) {
  let usePound = false;
  
  if (hex[0] === "#") {
    hex = hex.slice(1);
    usePound = true;
  }
  
  const num = parseInt(hex, 16);
  
  let r = (num >> 16) + amount;
  r = Math.max(Math.min(255, r), 0);
  
  let g = ((num >> 8) & 0x00FF) + amount;
  g = Math.max(Math.min(255, g), 0);
  
  let b = (num & 0x0000FF) + amount;
  b = Math.max(Math.min(255, b), 0);
  
  return (usePound ? "#" : "") + (g | (r << 8) | (b << 16)).toString(16).padStart(6, '0');
},


// Ajouter cette méthode dans la section "methods" du Dashboard Vue

async toggleBusinessMode(event) {
  try {
    // Mise à jour immédiate de l'interface
    this.profile.show_contact_button = event.target.checked ? 1 : 0;
    
    // Envoyer la mise à jour au serveur
    const response = await dashboardService.updateProfile(this.user.id, {
      name: this.profile.name,
      bio: this.profile.bio,
      company: this.profile.company,
      mobile: this.profile.mobile,
      show_contact_button: this.profile.show_contact_button
    });
    
    if (response.data && response.data.success) {
      this.notification = {
        type: 'success',
        message: this.profile.show_contact_button == 1 
          ? 'Mode Business activé' 
          : 'Mode Business désactivé'
      };
    } else {
      throw new Error(response.data?.message || 'Erreur lors de la mise à jour');
    }
  } catch (error) {
    console.error('Erreur toggle business mode:', error);
    
    // Annuler le changement en cas d'erreur
    this.profile.show_contact_button = this.profile.show_contact_button == 1 ? 0 : 1;
    event.target.checked = this.profile.show_contact_button == 1;
    
    this.notification = {
      type: 'danger',
      message: 'Erreur lors de la mise à jour'
    };
  }
},


async loadServices() {
    try {
      this.loading.services = true;
      const response = await dashboardService.getServices(this.user.id);
      
      if (response.data && response.data.success) {
        this.services = response.data.data || [];
      }
    } catch (error) {
      console.error('Erreur de chargement des services:', error);
    } finally {
      this.loading.services = false;
    }
  },

  // Ajouter un service


  // Dans Dashboard.vue, REMPLACEZ complètement la fonction addService par ceci :
// Dans Dashboard.vue, REMPLACEZ la fonction addService :



async addService() {
  try {
    if (!this.newService.name || !this.newService.url) {
      this.notification = {
        type: 'warning',
        message: 'Veuillez remplir le nom et l\'URL'
      };
      return;
    }

    // ÉTAPE 1: Créer le service SANS l'image
    const serviceData = {
      name: this.newService.name,
      url: this.newService.url,
      type: this.newService.type
    };

    const response = await dashboardService.addService(this.user.id, serviceData);
    
    if (response.data && response.data.success) {
      const newServiceId = response.data.data.id;
      
      // ÉTAPE 2: Si il y a une image, l'uploader séparément
      if (this.newService.icon_path && this.$refs.newServiceIcon && this.$refs.newServiceIcon.files[0]) {
        try {
          const formData = new FormData();
          formData.append('icon', this.$refs.newServiceIcon.files[0]);
          
          await dashboardService.uploadServiceIcon(this.user.id, newServiceId, formData);
          console.log('Image uploadée avec succès');
        } catch (iconError) {
          console.error('Erreur upload icône:', iconError);
          // Le service est créé, juste l'image qui a échoué
          this.notification = {
            type: 'warning',
            message: 'Service créé mais erreur lors de l\'upload de l\'image'
          };
        }
      }
      
      this.notification = {
        type: 'success',
        message: 'Service ajouté avec succès'
      };
      
      // Reset form
      this.newService = {
        name: '',
        url: '',
        type: 'link',
        icon_path: null
      };
      
      // Clear file input
      if (this.$refs.newServiceIcon) {
        this.$refs.newServiceIcon.value = '';
      }
      
      // Reload services
      await this.loadServices();
    } else {
      throw new Error(response.data?.message || 'Erreur lors de l\'ajout');
    }
  } catch (error) {
    console.error('Erreur d\'ajout de service:', error);
    this.notification = {
      type: 'danger',
      message: error.response?.data?.message || 'Erreur lors de l\'ajout du service'
    };
  }
},

  // Supprimer un service
  async deleteService(serviceId) {
    try {
      if (!confirm('Êtes-vous sûr de vouloir supprimer ce service ?')) return;

      const response = await dashboardService.deleteService(this.user.id, serviceId);
      
      if (response.data && response.data.success) {
        this.notification = {
          type: 'success',
          message: 'Service supprimé avec succès'
        };
        
        // Reload services
        await this.loadServices();
      } else {
        throw new Error(response.data?.message || 'Erreur lors de la suppression');
      }
    } catch (error) {
      console.error('Erreur de suppression de service:', error);
      this.notification = {
        type: 'danger',
        message: error.response?.data?.message || 'Erreur lors de la suppression du service'
      };
    }
  },

  // Upload icône service

  // Dans Dashboard.vue, MODIFIEZ aussi la fonction uploadServiceIcon :

  // Dans Dashboard.vue, REMPLACEZ uploadServiceIcon par cette version robuste :

async uploadServiceIcon(event, serviceId = null) {
  try {
    const file = event.target.files[0];
    if (!file) return;

    console.log('Upload pour service:', serviceId); // Debug

    // Si c'est pour un nouveau service (pas encore créé)
    if (!serviceId) {
      // Juste créer un aperçu temporaire
      const reader = new FileReader();
      reader.onload = (e) => {
        this.newService.icon_path = e.target.result;
      };
      reader.readAsDataURL(file);
      return;
    }

    // Upload pour un service existant
    this.loading.services = true;
    
    const formData = new FormData();
    formData.append('icon', file);

    console.log('Envoi vers:', `/api/data/users/${this.user.id}/services/${serviceId}/icon`);

    const response = await dashboardService.uploadServiceIcon(this.user.id, serviceId, formData);
    
    console.log('Réponse upload:', response.data);

    if (response.data && response.data.success) {
      this.notification = {
        type: 'success',
        message: 'Icône mise à jour avec succès'
      };
      
      // Forcer le rechargement des services
      await this.loadServices();
    } else {
      throw new Error(response.data?.message || 'Erreur lors de l\'upload');
    }
  } catch (error) {
    console.error('Erreur d\'upload d\'icône:', error);
    this.notification = {
      type: 'danger',
      message: error.response?.data?.message || 'Erreur lors de l\'upload de l\'icône'
    };
  } finally {
    this.loading.services = false;
  }
}


  },
  
  computed: {
  canAccessPhotos() {
    // Vérifier l'ID du package à partir des différentes sources possibles
    const packageId = 
      this.profile?.packageId || 
      this.profile?.package_id || 
      (this.currentSubscription ? this.currentSubscription.package_id : null);
    
    return packageId === 2 || packageId === 3;
  },
  
  themeCategories() {
    const categories = [...new Set(this.themes.map(theme => theme.category))];
    return categories;
  },
  
  filteredThemes() {
    if (this.currentCategory === 'Tous') {
      return this.themes;
    }
    return this.themes.filter(theme => theme.category === this.currentCategory);
  }
},

};
</script>

<style lang="scss" scoped>



// Variables améliorées
$primary-color: #000;
$primary-light: #333;
$primary-dark: #111;
$secondary-color: #6c757d;
$success-color: #198754;
$info-color: #0dcaf0;
$warning-color: #ffc107;
$danger-color: #dc3545;
$light-color: #f8f9fa;
$dark-color: #212529;

// Couleurs de fond et texte
$body-bg: #fafbfc;
$card-bg: #ffffff;
$sidebar-bg: #ffffff;
$border-color: #e5e9f2;
$text-primary: #2d3748;
$text-secondary: #718096;
$text-muted: #a0aec0;

// Espacements et dimensions
$sidebar-width: 280px;
$sidebar-width-collapsed: 70px;
$header-height: 70px;
$border-radius: 12px;
$border-radius-lg: 16px;
$border-radius-sm: 8px;
$box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
$box-shadow-hover: 0 8px 25px rgba(0, 0, 0, 0.08);
$transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

// Mixins utiles
@mixin flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin glass-effect {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@mixin hover-lift {
  transition: $transition;
  &:hover {
    transform: translateY(-2px);
    box-shadow: $box-shadow-hover;
  }
}

@mixin gradient-bg($color1, $color2) {
  background: linear-gradient(135deg, $color1 0%, $color2 100%);
}

// Reset et base
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: $body-bg;
  color: $text-primary;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dashboard {
  min-height: 100vh;
  position: relative;
}

// ===== SIDEBAR STYLES =====
.sidebar {
  background: $sidebar-bg;
  border-right: 1px solid $border-color;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.02);
  transition: $transition;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1000;
  overflow-y: auto;
  
  // Logo/Brand section
  .d-flex.align-items-center.mb-3 {
    padding: 1.5rem 1rem;
    border-bottom: 1px solid $border-color;
    margin-bottom: 0 !important;
    
    .fas.fa-qrcode {
      color: $primary-color;
      font-size: 1.5rem;
    }
    
    span {
      font-weight: 700;
      font-size: 1.25rem;
      color: $text-primary;
      letter-spacing: -0.025em;
    }
  }
  
  // Navigation
  .nav {
    padding: 1rem 0;
    
    .nav-item {
      margin-bottom: 0.25rem;
      
      .nav-link {
        padding: 0.875rem 1.5rem;
        border-radius: 0;
        color: $text-primary; // ← TEXTE NOIR AU LIEU DE GRIS
        font-weight: 500;
        font-size: 0.925rem;
        transition: $transition;
        border: none;
        position: relative;
        overflow: hidden;
        
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 4px;
          background: $primary-color;
          transform: scaleY(0);
          transition: transform 0.3s ease;
        }
        
        &:hover {
          background: rgba($primary-color, 0.06);
          color: $primary-color;
          transform: none;
        }
        
        &.active {
          background: rgba($primary-color, 0.1);
          color: $primary-color;
          font-weight: 600;
          
          &::before {
            transform: scaleY(1);
          }
        }
        
        i {
          width: 20px;
          font-size: 1rem;
          margin-right: 0.875rem;
          text-align: center;
        }
      }
    }
  }
  
  // Mobile styles
  @media (max-width: 991px) {
    left: -100%;
    
    &.show {
      left: 0;
    }
    
    .btn-close {
      position: absolute;
      top: 1rem;
      right: 1rem;
      z-index: 10;
    }
  }
}

// ===== MAIN CONTENT =====
main {
  margin-left: $sidebar-width;
  min-height: 100vh;
  padding: 0;
  transition: $transition;
  
  @media (max-width: 991px) {
    margin-left: 0;
  }
}

// ===== HEADER =====
header {
  background: $card-bg;
  border-bottom: 1px solid $border-color;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 999;
  backdrop-filter: blur(10px);
  
  h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: $text-primary;
    margin: 0;
    
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
.btn-toolbar {
    gap: 0.75rem;
    
    .btn {
      border-radius: $border-radius-sm;
      border: 1px solid $border-color;
      background: $card-bg;
      color: $text-secondary;
      transition: $transition;
      
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
        transform: translateY(-1px);
      }
    }
    
    // FIX pour le bouton menu hamburger
    .btn.d-lg-none {
      padding: 0.5rem; // ← PADDING FIXE
      width: 40px; // ← LARGEUR FIXE
      height: 40px; // ← HAUTEUR FIXE
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        font-size: 1.25rem !important; // ← TAILLE ICÔNE FIXE
      }
    }
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 1.125rem !important;
    }
  }
}
  
  .btn-toolbar {
    gap: 0.75rem;
    
    .btn {
      border-radius: $border-radius-sm;
      border: 1px solid $border-color;
      background: $card-bg;
      color: $text-secondary;
      transition: $transition;
      
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
        transform: translateY(-1px);
      }
    }
  }
  
  .dropdown-menu {
    border: 1px solid $border-color;
    box-shadow: $box-shadow;
    border-radius: $border-radius;
    padding: 0.5rem 0;
    
    .dropdown-item {
      padding: 0.625rem 1rem;
      color: $text-secondary;
      transition: $transition;
      
      &:hover {
        background: rgba($primary-color, 0.06);
        color: $primary-color;
      }
    }
  }


  @media (max-width: 768px) {
    h1 {
      font-size: 1.125rem !important; // ← RÉDUIRE LE TITRE
    }
  }


  .btn-toolbar {
    gap: 0.75rem;
    
    .btn {
      border-radius: $border-radius-sm;
      border: 1px solid $border-color;
      background: $card-bg;
      color: $text-secondary;
      transition: $transition;
      
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
        transform: translateY(-1px);
      }
    }
    
    // FIX pour le bouton menu hamburger
    .btn.d-lg-none {
      padding: 0.5rem; // ← PADDING FIXE
      width: 40px; // ← LARGEUR FIXE
      height: 40px; // ← HAUTEUR FIXE
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        font-size: 1.25rem !important; // ← TAILLE ICÔNE FIXE
      }
    }
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 1.125rem !important;
    }
  }
}




// ===== NOTIFICATIONS =====
.alert {
  border-radius: $border-radius;
  border: none;
  padding: 1rem 1.25rem;
  font-weight: 500;
  box-shadow: $box-shadow;
  
  &-success {
    background: rgba($success-color, 0.1);
    color: darken($success-color, 10%);
  }
  
  &-warning {
    background: rgba($warning-color, 0.1);
    color: darken($warning-color, 20%);
  }
  
  &-danger {
    background: rgba($danger-color, 0.1);
    color: darken($danger-color, 10%);
  }
  
  &-info {
    background: rgba($info-color, 0.1);
    color: darken($info-color, 20%);
  }
  
  .btn-close {
    filter: none;
    opacity: 0.7;
    
    &:hover {
      opacity: 1;
    }
  }
}

// ===== CARDS =====
.card {
  background: $card-bg;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  transition: $transition;
  overflow: hidden;
  
  &:hover {
    box-shadow: $box-shadow-hover;
  }
  
  .card-header {
    background: rgba($light-color, 0.5);
    border-bottom: 1px solid $border-color;
    padding: 1.25rem 1.5rem;
    
    .card-title {
      font-size: 1.125rem;
      font-weight: 600;
      color: $text-primary;
      margin: 0;
    }
  }
  
  .card-body {
    padding: 1.5rem;
  }
}

// ===== ANALYTICS CARDS =====
.text-bg-primary {
  @include gradient-bg($primary-color, lighten($primary-color, 10%));
  
  .card-subtitle {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  
  .card-title {
    color: white;
    font-weight: 700;
    font-size: 2rem;
  }
}

.text-bg-warning {
  @include gradient-bg($warning-color, darken($warning-color, 10%));
  
  .card-subtitle {
    color: rgba(0, 0, 0, 0.7) !important;
  }
}

.text-bg-info {
  @include gradient-bg($info-color, darken($info-color, 10%));
  
  .card-subtitle {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}

.text-bg-success {
  @include gradient-bg($success-color, darken($success-color, 10%));
  
  .card-subtitle {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}

// ===== FORMS =====
.form-control, .form-select {
  border: 1px solid $border-color;
  border-radius: $border-radius-sm;
  padding: 0.75rem 1rem;
  font-size: 0.925rem;
  transition: $transition;
  background: $card-bg;
  
  &:focus {
    border-color: $primary-color;
    box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
    outline: none;
  }
  
  &::placeholder {
    color: $text-muted;
  }
}

.form-label {
  font-weight: 600;
  color: $text-primary;
  margin-bottom: 0.5rem;
  font-size: 0.925rem;
  text-align: left !important;
  display: block !important;
  width: 100% !important;
}

// ===== BUTTONS =====
.btn {
  border-radius: $border-radius-sm;
  padding: 0.625rem 1.25rem;
  font-weight: 600;
  font-size: 0.925rem;
  transition: $transition;
  border: none;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.3s, height 0.3s;
  }
  
  &:hover::before {
    width: 300px;
    height: 300px;
  }
  
  &-primary {
    background: $primary-color;
    color: white;
    
    &:hover {
      background: $primary-light;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba($primary-color, 0.3);
    }
  }
  
  &-success {
    background: $success-color;
    color: white;
    
    &:hover {
      background: darken($success-color, 5%);
      transform: translateY(-1px);
    }
  }
  
  &-danger {
    background: $danger-color;
    color: white;
    
    &:hover {
      background: darken($danger-color, 5%);
      transform: translateY(-1px);
    }
  }
  
  &-outline-primary {
    border: 1px solid $primary-color;
    color: $primary-color;
    background: transparent;
    
    &:hover {
      background: $primary-color;
      color: white;
      transform: translateY(-1px);
    }
  }
  
  &-outline-secondary {
    border: 1px solid $border-color;
    color: $text-secondary;
    background: transparent;
    
    &:hover {
      background: $light-color;
      border-color: $primary-color;
      color: $primary-color;
    }
  }
  
  // Responsive button
  &-responsive {
    @media (max-width: 767px) {
      width: 100%;
      padding: 0.875rem 1.5rem;
    }
    
    @media (min-width: 768px) and (max-width: 991px) {
      width: 80%;
      padding: 0.875rem 2rem;
    }
    
    @media (min-width: 992px) {
      width: auto;
      min-width: 250px;
      padding: 1rem 3rem;
    }
  }
}

// ===== TABLES =====
.table {
  border-collapse: separate;
  border-spacing: 0;
  
  th {
    background: rgba($light-color, 0.5);
    border-bottom: 1px solid $border-color;
    font-weight: 600;
    color: $text-primary;
    padding: 1rem;
    font-size: 0.925rem;
  }
  
 
  td {
  padding: 1rem;
  border-bottom: 1px solid $border-color;
  color: $text-primary; // ← TEXTE NOIR AU LIEU DE GRIS
  vertical-align: middle;
}
  
  tbody tr {
    transition: $transition;
    
    &:hover {
      background: rgba($primary-color, 0.02);
    }
  }
}

// ===== BADGES =====
.badge {
  border-radius: $border-radius-sm;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  font-size: 0.775rem;
  
  &.bg-secondary {
    background: $text-secondary !important;
    color: white;
    
    .btn {
      color: white;
      background: none;
      border: none;
      padding: 0;
      margin-left: 0.5rem;
      
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  
  &.bg-success {
    background: $success-color !important;
    color: white;
  }
  
  &.bg-dark {
    background: $dark-color !important;
    color: white;
  }
}

// ===== PAYMENT MODAL =====
.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  @include flex-center;
  z-index: 10000;
  animation: fadeIn 0.3s ease-out;
}

.payment-content {
  background: $card-bg;
  border-radius: $border-radius-lg;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  width: 90%;
  max-width: 480px;
  position: relative;
  animation: slideUp 0.3s ease-out;
  
  @media (max-width: 480px) {
    width: 95%;
    padding: 1.5rem;
  }
}

.close-button {
  position: absolute;
  right: 1rem;
  top: 1rem;
  background: rgba($light-color, 0.8);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 1.25rem;
  @include flex-center;
  cursor: pointer;
  transition: $transition;
  color: $text-secondary;
  
  &:hover {
    background: $border-color;
    color: $text-primary;
    transform: rotate(90deg);
  }
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  margin: 1.5rem 0;
}

.payment-card {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: 2px solid $border-color;
  border-radius: $border-radius;
  cursor: pointer;
  transition: $transition;
  position: relative;
  background: $card-bg;
  
  &:hover {
    border-color: $primary-color;
    transform: translateY(-2px);
    box-shadow: $box-shadow-hover;
  }
  
  &.selected {
    border-color: $primary-color;
    background: rgba($primary-color, 0.03);
    box-shadow: 0 0 0 4px rgba($primary-color, 0.1);
  }
}

.payment-icon {
  @include flex-center;
  width: 50px;
  height: 50px;
  border-radius: $border-radius;
  margin-right: 1rem;
  color: white;
  font-size: 1.25rem;
  
  &.bg-info {
    @include gradient-bg($info-color, darken($info-color, 10%));
  }
}

.payment-details {
  flex: 1;
  
  h6 {
    margin: 0 0 0.5rem 0;
    font-weight: 600;
    font-size: 1rem;
    color: $text-primary;
    @include flex-center;
    justify-content: center;
    
    i {
      font-size: 0.875rem;
      margin-right: 0.5rem;
    }
  }
}

.card-logos {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  margin: 0.75rem 0 0.5rem 0;
}

.card-logo {
  height: 28px;
  width: auto;
  max-width: 45px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid $border-color;
  padding: 3px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: $transition;
  
  &:hover {
    transform: scale(1.05);
  }
}

.check-icon {
  position: absolute;
  right: 1rem;
  color: $primary-color;
  font-size: 1.25rem;
  animation: checkBounce 0.3s ease-out;
}

.payment-summary {
  background: rgba($light-color, 0.6);
  padding: 1.5rem;
  border-radius: $border-radius;
  margin: 1.5rem 0;
  border: 1px solid rgba($border-color, 0.5);
  
  h6 {
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: $text-primary;
  }
  
  .d-flex {
    margin-bottom: 0.75rem;
    font-size: 0.925rem;
    
    span:first-child {
      color: $text-secondary;
    }
    
    span:last-child {
      color: $text-primary;
      font-weight: 600;
    }
  }
  
  hr {
    border-color: $border-color;
    margin: 1rem 0;
  }
  
  .small {
    color: $text-muted;
    line-height: 1.5;
  }
}

// ===== THEME CARDS =====
.theme-card {
  cursor: pointer;
  transition: $transition;
  overflow: hidden;
  border: 2px solid transparent;
  
  @include hover-lift;
  
  &.selected {
    border-color: $primary-color;
    box-shadow: 0 0 0 4px rgba($primary-color, 0.1);
    
    .badge {
      animation: pulse 2s infinite;
    }
  }
}

.theme-preview {
  height: 160px;
  overflow: hidden;
  position: relative;
  @include flex-center;
}

.theme-name {
  color: white;
  font-weight: 700;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
  font-size: 1.125rem;
  opacity: 0;
  transition: $transition;
  letter-spacing: 0.025em;
}

.theme-card:hover .theme-name {
  opacity: 1;
  transform: translateY(-4px);
}

// ===== QR CODE =====
.qr-code-container {
  display: inline-block;
  padding: 1.5rem;
  background: white;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  border: 1px solid $border-color;
  transition: $transition;
  
  &:hover {
    box-shadow: $box-shadow-hover;
    transform: translateY(-2px);
  }
  
  img {
    display: block;
    max-width: 250px;
    height: auto;
  }
}

// ===== FORM SWITCHES =====
.form-check-input {
  &:checked {
    background-color: $primary-color;
    border-color: $primary-color;
  }
  
  &:focus {
    box-shadow: 0 0 0 3px rgba($primary-color, 0.2);
  }
}

// ===== LOADING STATES =====
.spinner-border {
  &.text-primary {
    color: $primary-color !important;
  }
}

// ===== ANIMATIONS =====
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes checkBounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease-out;
}

// ===== RESPONSIVE UTILITIES =====
@media (max-width: 768px) {
  .container-fluid {
    padding: 0.75rem;
  }
  
  header {
    padding: 0.75rem 1rem;
    
    h1 {
      font-size: 1.375rem;
    }
  }
  
  .card {
    margin-bottom: 1rem;
    
    .card-body {
      padding: 1rem;
    }
  }
  
  .payment-content {
    margin: 1rem;
  }
  
  // Stack analytics cards on mobile
  .row-cols-lg-4 {
    .col {
      margin-bottom: 1rem;
    }
  }
}

@media (max-width: 480px) {
  .btn-toolbar {
    gap: 0.5rem;
    
    .btn {
      padding: 0.5rem;
      font-size: 0.875rem;
    }
  }
  
  .form-control, .form-select {
    font-size: 16px; // Prevent zoom on iOS
  }
}

// ===== BUSINESS MODE TOGGLE =====
.business-mode-card {
  border: 1px solid $border-color;
  border-radius: $border-radius;
  padding: 1.25rem;
  background: rgba($light-color, 0.3);
  transition: $transition;
  
  &:hover {
    border-color: rgba($primary-color, 0.3);
    background: rgba($primary-color, 0.02);
  }
  
  .form-check-input {
    width: 3rem;
    height: 1.5rem;
    cursor: pointer;
  }
}

// ===== BUSINESS MODE HEADER =====
.business-mode-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: rgba($light-color, 0.6);
  border-radius: $border-radius-sm;
  border: 1px solid $border-color;
  
  .text-muted {
    font-size: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .form-check {
    margin-bottom: 0;
  }
  
  .form-check-input {
    cursor: pointer;
    
    &:checked {
      background-color: $success-color;
      border-color: $success-color;
    }
  }


  @media (max-width: 768px) {
    padding: 0.25rem 0.5rem; // ← RÉDUIRE LE PADDING
    
    .text-muted {
      display: none; // ← MASQUER LE TEXTE
    }
    
    .form-check-input {
      width: 2rem !important; // ← SWITCH PLUS PETIT
      height: 1rem !important;
    }
  }
}

// Ajustement du dropdown menu
.dropdown-menu-end {
  min-width: 200px;
  
  .dropdown-item {
    padding: 0.75rem 1rem;
    
    i {
      width: 20px;
      text-align: center;
    }
  }
}

// ===== ACCESSIBILITY =====
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}


// AJOUTER CES STYLES DANS Dashboard.vue <style>

// ===== SERVICES STYLES =====
.service-card {
  transition: $transition;
  border: 1px solid $border-color;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: $box-shadow-hover;
  }
}

.service-icon-container {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $border-radius-sm;
  background: rgba($light-color, 0.5);
}

.service-icon {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
}

.service-icon-placeholder {
  width: 32px;
  height: 32px;
  @include flex-center;
  background: rgba($text-muted, 0.1);
  border-radius: 4px;
  color: $text-muted;
  
  i {
    font-size: 16px;
  }
}

.service-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: $text-primary;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.service-actions {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  
  .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
}

.icon-preview {
  width: 48px;
  height: 48px;
  border: 1px solid $border-color;
  border-radius: $border-radius-sm;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.preview-icon {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
}
</style>